export const chunk = <T>(data: T[] | void | null, size: number | void | null): T[][] => {
  if (!data || !size) {
    return [];
  }
  const results = [];
  const incomingArray = data.slice();

  while (incomingArray.length) {
    results.push(incomingArray.splice(0, size));
  }

  return results;
};
